module.exports = __webpack_public_path__ + "static/media/searchTalents.b19312fb.png";